import { useState } from "react"
import { useUploadImageMutation } from "../../API/authApi";
import { ImageTypes } from "../../Interfaces/componentTypes";

const useUploadFile = (type: ImageTypes) => {
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [uploadImage, { data: ImageResponce, isLoading: imageLoading, isSuccess: imageLoadingSuccess, isError: imageLoadingError }] = useUploadImageMutation();

  const handleFileInputChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    try {
      const file = event.target.files?.[0];
      if (file) {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = async () => {
          const maxWidth = 800;  
          const maxHeight = 1000; 
          let newWidth = img.width;
          let newHeight = img.height;
          if (newWidth > maxWidth || newHeight > maxHeight) {
            const aspectRatio = img.width / img.height;
            if (newWidth > maxWidth) {
              newWidth = maxWidth;
              newHeight = newWidth / aspectRatio;
            }
            if (newHeight > maxHeight) {
              newHeight = maxHeight;
              newWidth = newHeight * aspectRatio;
            }
          }

          const canvas = document.createElement("canvas");
          canvas.width = newWidth;
          canvas.height = newHeight;
          const ctx = canvas.getContext("2d");
          ctx?.drawImage(img, 0, 0, newWidth, newHeight);
          canvas.toBlob(async (blob) => {
            if (!blob) return;
            const resizedFile = new File([blob], file.name, { type: file.type });
             const formData = new FormData();
            formData.append('src', resizedFile);
            formData.append('image_type', type);
            if (ImageResponce && type !== ImageTypes.GALLERY) {
              formData.append('prev_image_src', String(ImageResponce?.src));
            }

            await uploadImage(formData);
            setImageUrl(URL.createObjectURL(resizedFile));
          }, file.type);
        };
      }
    } catch (error) {
      console.error('Error selecting an image:', error);
    }
  };

  return {
    imageUrl,
    imageLoading,
    ImageResponce,
    imageLoadingError,
    imageLoadingSuccess,
    handleFileInputChange,
  }
};

export default useUploadFile